export default function useParentMessage() {
    

  
  const scrollToPoint = (pixels: string) => {
    // const numbers = pixels.match(/\d+/g);
    // console.log("TO WYSYLAM TYLE PIXELI DO SCROLLA")
    // console.log(numbers)
    // window.parent.postMessage("scroll::" + numbers, "*");
  };



  const scrollToTop = () => {
    window.parent.postMessage("scrollToTop::", "*");
    window.scrollTo(0, 0);
  };

  const scrollToCenter = () => {
    window.parent.postMessage("scrollToCenter::", "*");
  };

  const updateScrollPosition = () => {
    window.parent.postMessage("updateScrollPosition::", "*");
  };

  const scrollToId = (idName: string) => {
    const el = document.getElementById(idName);
    if (el !== null) {
      let distance = window.scrollY + el.getBoundingClientRect().top;

      window.parent.postMessage("scrollToId::" + distance, "*");
    }
  };

  const forceGoToPayment = (paymentUrl: string) => {
    window.parent.postMessage("paymentLink::" + paymentUrl, "*");
  };

  return {
    scrollToPoint,
    forceGoToPayment,
    scrollToId,
    scrollToTop,
    scrollToCenter,
    updateScrollPosition,
  };
}

